import { useAppScopeStore } from '@frontend/scope';
import { useMessagingAIRCustomizationFlag, useVoiceAIRCustomizationFlag } from '@frontend/shared';

export const useAiReceptionistAccess = () => {
  const { selectedLocationIds } = useAppScopeStore();

  const { truelarkVoiceAIActive: hasTlAiVoiceAccess, weaveVoiceAIActive: hasWeaveAiVoiceAccess } =
    useVoiceAIRCustomizationFlag(selectedLocationIds);
  const { truelarkMessagingAIActive: hasTlAiMessagingAccess, weaveMessagingAIActive: hasWeaveAiMessagingAccess } =
    useMessagingAIRCustomizationFlag(selectedLocationIds);

  const hasTlAiReceptionistAccess = hasTlAiVoiceAccess || hasTlAiMessagingAccess;
  const hasWeaveAiReceptionistAccess = hasWeaveAiVoiceAccess || hasWeaveAiMessagingAccess;
  const hasAiReceptionistAccess = hasTlAiReceptionistAccess || hasWeaveAiReceptionistAccess;

  return {
    hasTlAiVoiceAccess,
    hasWeaveAiVoiceAccess,
    hasTlAiMessagingAccess,
    hasWeaveAiMessagingAccess,
    hasAiReceptionistAccess,
    hasTlAiReceptionistAccess,
    hasWeaveAiReceptionistAccess,
  };
};
